function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function Work({
  width = 24,
  height = 24,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M11.995 16.701v-2.457",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M18.19 5.713c1.69 0 3.05 1.327 3.05 2.963v3.332c-2.46 1.395-5.71 2.237-9.25 2.237s-6.78-.842-9.24-2.237V8.667c0-1.637 1.37-2.954 3.06-2.954h12.38z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M15.495 5.708v-.355c0-1.181-.99-2.14-2.21-2.14h-2.58c-1.22 0-2.21.959-2.21 2.14v.355M2.774 15.545l.19 2.43c.127 1.637 1.536 2.903 3.231 2.903h11.6c1.694 0 3.103-1.265 3.231-2.903l.19-2.43",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=Work.js.map